import DisclosureMenu from "./src/disclosureMenu.js";
import Menubar from "./src/menubar.js";
import Treeview from "./src/treeview.js";

const disclosureMenu = DisclosureMenu;
const menubar = Menubar;
const treeview = Treeview;

export { disclosureMenu as DisclosureMenu };
export { menubar as Menubar };
export { treeview as Treeview };
export default {
  DisclosureMenu,
  Menubar,
  Treeview,
};
